<template>
    <div>
        <div v-if="!value.shortFormat" class="time-window">
            <label class="col-xs-3">{{ $t('reports.labels.startTime') }}</label>
            <div tabindex="1" class="col-xs-4 datepicker-window">
                <span v-if="$v.dateFromFormatted.$invalid" class="tooltiptext date-left">{{
                    errorDisplay($v.dateFromFormatted, { val: getDateFormat() })
                }}</span>
                <input
                    v-model="dateFromFormatted"
                    :maxlength="DATE_LENGHT"
                    :class="['time-input', { tooltiperror: $v.dateFromFormatted.$invalid }]"
                    :placeholder="$t('reports.labels.date')"
                    @input="updateDateFrom($event.target.value)"
                />
                <i class="icon-calendar" @click="openedFromDate = !openedFromDate"></i>
            </div>
            <div>
                <DatePicker
                    v-model="fromDate"
                    :opened="openedFromDate"
                    @checkvalid="updateInputDateFrom()"
                    @close="openedFromDate = false"
                />
            </div>
            <label>&mdash;</label>
            <div class="col-xs-4 timepicker-window">
                <span v-if="$v.timeFromFormatted.$invalid" class="tooltiptext date-right">{{
                    errorDisplay($v.timeFromFormatted, { val: getTimeNoSecondsFormat() })
                }}</span>
                <input
                    ref="timePickerFrom"
                    v-model="timeFromFormatted"
                    :maxlength="timeLenght"
                    :class="['time-input', { tooltiperror: $v.timeFromFormatted.$invalid }]"
                    :placeholder="dateFromFormatted ? default_time_from : $t('reports.labels.time')"
                    :disabled="!dateFromFormatted"
                    @input="updateTimeFrom($event.target.value)"
                />
                <i class="icon-time" @mousedown.prevent="toggleFromTimeList"></i>
            </div>
            <div>
                <TimePicker
                    v-model="fromDate"
                    :opened="openedFromTime"
                    @close="closeTimeFrom"
                    @checkvalid="updateInputTimeFrom()"
                    @away="closeTimeFromAway"
                />
            </div>
        </div>

        <div v-if="!value.shortFormat" class="time-window">
            <label class="col-xs-3">{{ $t('reports.labels.endTime') }}</label>
            <div tabindex="3" class="col-xs-4 datepicker-window">
                <span v-if="$v.dateToFormatted.$invalid" class="tooltiptext date-left">{{
                    errorDisplay($v.dateToFormatted, { val: getDateFormat() })
                }}</span>
                <input
                    v-model="dateToFormatted"
                    :maxlength="DATE_LENGHT"
                    :class="['time-input', { tooltiperror: $v.dateToFormatted.$invalid }]"
                    :placeholder="$t('reports.labels.date')"
                    @input="updateDateTo($event.target.value)"
                />
                <i class="icon-calendar" @click="openedToDate = !openedToDate"></i>
            </div>
            <div>
                <DatePicker
                    v-model="toDate"
                    :opened="openedToDate"
                    @checkvalid="updateInputDateTo()"
                    @close="openedToDate = false"
                />
            </div>
            <label>&mdash;</label>
            <div class="col-xs-4 timepicker-window">
                <span v-if="$v.timeToFormatted.$invalid" class="tooltiptext date-right">{{
                    errorDisplay($v.timeToFormatted, { val: getTimeNoSecondsFormat() })
                }}</span>
                <input
                    ref="timePickerTo"
                    v-model="timeToFormatted"
                    :maxlength="timeLenght"
                    :class="['time-input', { tooltiperror: $v.timeToFormatted.$invalid }]"
                    :placeholder="dateToFormatted ? default_time_to : $t('reports.labels.time')"
                    :disabled="!dateToFormatted"
                    @input="updateTimeTo($event.target.value)"
                />
                <i class="icon-time" @mousedown.prevent="toggleToTimeList"></i>
            </div>
            <div>
                <TimePicker
                    v-model="toDate"
                    :opened="openedToTime"
                    @close="closeTimeTo"
                    @checkvalid="updateInputTimeTo()"
                    @away="closeTimeToAway"
                />
            </div>
        </div>

        <div v-if="value.shortFormat" class="time-window">
            <div :class="['col-xs-5', 'datepicker-window', { active: openedFromDate }]">
                <input
                    v-model="dateFromFormatted"
                    :class="['time-input', { tooltiperror: $v.dateFromFormatted.$invalid }]"
                    :disabled="value.disabled"
                    :placeholder="$t('reports.labels.date')"
                    @input="updateDateFrom($event.target.value)"
                />
                <span v-if="$v.dateFromFormatted.$invalid" class="tooltiptext date-left">{{
                    errorDisplay($v.dateFromFormatted, { val: getDateFormat() })
                }}</span>
                <i class="icon-calendar" @click="openedFromDate = !openedFromDate && !value.disabled"></i>
            </div>
            <div>
                <DatePicker
                    v-model="fromDate"
                    :opened="openedFromDate"
                    :disabled="value.disabled"
                    @checkvalid="updateInputDateFrom()"
                    @close="openedFromDate = false"
                />
            </div>
            <div class="label-to">to</div>
            <div :class="['col-xs-5', 'datepicker-window', { active: openedToDate }]">
                <input
                    v-model="dateToFormatted"
                    :class="['time-input', { tooltiperror: $v.dateToFormatted.$invalid }]"
                    :disabled="value.disabled"
                    :placeholder="$t('reports.labels.date')"
                    @input="updateDateTo($event.target.value)"
                />
                <span v-if="$v.dateToFormatted.$invalid" class="tooltiptext date-right">{{
                    errorDisplay($v.dateToFormatted, { val: getDateFormat() })
                }}</span>
                <i class="icon-calendar" @click="openedToDate = !openedToDate && !value.disabled"></i>
            </div>
            <div>
                <DatePicker
                    v-model="toDate"
                    :opened="openedToDate"
                    date-class="right-date"
                    @checkvalid="updateInputDateTo()"
                    @close="openedToDate = false"
                />
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import DatePicker from './DatePicker.vue';
import TimePicker from './TimePicker.vue';
import { errorDisplay } from '../../../validators';
import parse from 'date-fns/parse';
import isBefore from 'date-fns/isBefore';
import format from 'date-fns/format';
import isMatch from 'date-fns/isMatch';
import { DATE_LENGHT, DEFAULT_TIME_FROM, DEFAULT_TIME_TO } from '../../../constants';
import { getDateFormat, formatTime, getTimeNoSecondsFormat } from '../helpers';
import set from 'date-fns/set';
import getHours from 'date-fns/getHours';
import getMinutes from 'date-fns/getMinutes';

export default {
    components: {
        DatePicker,
        TimePicker,
    },
    constants: {
        DATE_LENGHT,
        DEFAULT_TIME_FROM,
        DEFAULT_TIME_TO,
    },
    props: {
        value: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {
            openedFromDate: false,
            openedFromTime: false,
            openedToDate: false,
            openedToTime: false,
            incorrectDateFrom: false,
            incorrectDateTo: false,
            dateFromFormatted: '',
            dateToFormatted: '',
            timeFromFormatted: '',
            timeToFormatted: '',
            timeLenght: formatTime('00:00').length,
            default_time_from: formatTime(DEFAULT_TIME_FROM),
            default_time_to: formatTime(DEFAULT_TIME_TO),
        };
    },

    computed: {
        fromDate: {
            get: function() {
                let date;
                if (this.value.from.date !== null && this.value.from.date !== '') {
                    date =
                        this.value.from.date instanceof Date
                            ? this.value.from.date
                            : new Date(parseInt(this.value.from.date));
                } else {
                    date = null;
                }
                return date;
            },
            set: function(val) {
                this.value.from.date = val;
            },
        },

        toDate: {
            get: function() {
                let date;
                if (this.value.to.date !== null && this.value.to.date !== '') {
                    date =
                        this.value.to.date instanceof Date
                            ? this.value.to.date
                            : new Date(parseInt(this.value.to.date));
                } else {
                    date = null;
                }
                return date;
            },
            set: function(val) {
                this.value.to.date = val;
            },
        },
    },
    mounted() {
        this.$watch('$v.validationGroup.$invalid', value => {
            this.value.invalid = value;
        });
    },

    created() {
        this.updateDateFields();
    },

    methods: {
        errorDisplay,
        getDateFormat,
        getTimeNoSecondsFormat,

        updateDateFields() {
            if (this.fromDate) {
                this.dateFromFormatted = format(this.fromDate, getDateFormat());
                this.timeFromFormatted = format(this.fromDate, getTimeNoSecondsFormat());
            }
            if (this.toDate) {
                this.dateToFormatted = format(this.toDate, getDateFormat());
                this.timeToFormatted = format(this.toDate, getTimeNoSecondsFormat());
            }
        },

        /**
         * Update the date if user type date in field manually
         */
        updateDateFrom(val) {
            if (val.length === 0) {
                this.value.from.date = null;
                return;
            }
            if (this.incorrectDateChecker(val)) {
                let date = parse(val, getDateFormat(), new Date());
                let time =
                    this.timeFromFormatted !== ''
                        ? parse(this.timeFromFormatted, getTimeNoSecondsFormat(), new Date())
                        : parse('00:00', 'HH:mm', new Date());
                let fullDate = set(date, {
                    hours: getHours(time),
                    minutes: getMinutes(time),
                    seconds: 0,
                    milliseconds: 0,
                });
                this.value.from.date = fullDate;
            }
        },

        /**
         * Update the date if user type date in field manually
         */
        updateDateTo(val) {
            if (val.length === 0) {
                this.value.to.date = null;
                return;
            }
            if (this.incorrectDateChecker(val)) {
                let date = parse(val, getDateFormat(), new Date());
                let time =
                    this.timeToFormatted !== ''
                        ? parse(this.timeToFormatted, getTimeNoSecondsFormat(), new Date())
                        : parse('23:59', 'HH:mm', new Date());
                let fullDate = set(date, {
                    hours: getHours(time),
                    minutes: getMinutes(time),
                    seconds: 0,
                    milliseconds: 0,
                });
                this.value.to.date = fullDate;
            }
        },

        /**
         * Update the time if user type time in field manually
         */
        updateTimeFrom(val) {
            this.timeFromFormatted = val;
            if (this.timeFromFormatted === '') {
                let fullDate = set(this.value.from.date, {
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                    milliseconds: 0,
                });
                this.value.from.date = fullDate;
                return;
            }
            if (this.incorrectTimeChecker(val)) {
                let date = parse(val, getTimeNoSecondsFormat(), new Date());
                let fullDate = set(this.fromDate, {
                    hours: getHours(date),
                    minutes: getMinutes(date),
                    seconds: 0,
                    milliseconds: 0,
                });
                this.value.from.date = fullDate;
            }
        },

        /**
         * Update the time if user type time in field manually
         */
        updateTimeTo(val) {
            this.timeToFormatted = val;
            if (this.timeToFormatted === '') {
                let fullDate = set(this.toDate, {
                    hours: 23,
                    minutes: 59,
                    seconds: 0,
                    milliseconds: 0,
                });
                this.value.to.date = fullDate;
                return;
            }
            if (this.incorrectTimeChecker(val)) {
                let date = parse(val, getTimeNoSecondsFormat(), new Date());
                let fullDate = set(this.toDate, {
                    hours: getHours(date),
                    minutes: getMinutes(date),
                    seconds: 0,
                    milliseconds: 0,
                });
                this.value.to.date = fullDate;
            }
        },

        /**
         * Update date text in the input for Date from
         */
        updateInputDateFrom() {
            this.$nextTick(() => {
                // Fill the time field if date field was empty
                if (this.dateFromFormatted === '') {
                    if (this.timeFromFormatted === '') {
                        this.updateInputTimeFrom(this.fromDate);
                    }
                }
                this.dateFromFormatted = format(this.fromDate, getDateFormat());
            });
        },

        /**
         * Update date text in the input for Date to
         */
        updateInputDateTo() {
            this.$nextTick(() => {
                // Fill the time field if date field was empty
                if (this.dateToFormatted === '') {
                    if (this.timeToFormatted === '') {
                        this.updateInputTimeTo(
                            set(this.toDate, {
                                hours: 23,
                                minutes: 59,
                                seconds: 0,
                                milliseconds: 0,
                            })
                        );
                    }
                }
                this.dateToFormatted = format(this.toDate, getDateFormat());
            });
        },

        /**
         * Update time text in the input fot Time from
         */
        updateInputTimeFrom() {
            this.$nextTick(() => {
                if (this.fromDate) {
                    this.timeFromFormatted = format(this.fromDate, getTimeNoSecondsFormat());
                }
            });
        },

        /**
         * Update time text in the input fot Time to
         */
        updateInputTimeTo() {
            this.$nextTick(() => {
                if (this.toDate) {
                    this.timeToFormatted = format(this.toDate, getTimeNoSecondsFormat());
                }
            });
        },

        incorrectDateChecker(val) {
            return val.length > 0 ? val.length === DATE_LENGHT && isMatch(val, getDateFormat()) : true;
        },

        incorrectTimeChecker(val) {
            return val.length > 0
                ? isMatch(val, getTimeNoSecondsFormat()) && val.length === this.timeLenght
                : true;
        },

        toggleFromTimeList() {
            this.openedFromTime = !this.openedFromTime && !!this.value.from.date;
        },

        toggleToTimeList() {
            this.openedToTime = !this.openedToTime && !!this.value.to.date;
        },

        closeTimeFrom() {
            this.openedFromTime = false;
            this.$nextTick(() => {
                this.$refs.timePickerFrom.select();
            });
        },

        closeTimeTo() {
            this.openedToTime = false;
            this.$nextTick(() => {
                this.$refs.timePickerTo.select();
            });
        },

        closeTimeFromAway() {
            this.openedFromTime = false;
        },

        closeTimeToAway() {
            this.openedToTime = false;
        },
    },

    validations() {
        return {
            dateFromFormatted: {
                incorrectDate: val => {
                    return this.incorrectDateChecker(val);
                },
                timeDiffFrom: () => {
                    if (this.value.from.date && this.value.to.date) {
                        return isBefore(
                            set(this.fromDate, { seconds: 0, milliseconds: 0 }),
                            set(this.toDate, { seconds: 0, milliseconds: 0 })
                        );
                    }
                    return true;
                },
            },
            dateToFormatted: {
                incorrectDate: val => {
                    return this.incorrectDateChecker(val);
                },
                timeDiffTo: () => {
                    if (this.value.from.date && this.value.to.date) {
                        return isBefore(
                            set(this.fromDate, { seconds: 0, milliseconds: 0 }),
                            set(this.toDate, { seconds: 0, milliseconds: 0 })
                        );
                    }
                    return true;
                },
            },
            timeFromFormatted: {
                incorrectTime: val => {
                    return this.incorrectTimeChecker(val);
                },
                timeDiffFrom: () => {
                    if (this.value.from.date && this.value.to.date) {
                        return isBefore(
                            set(this.fromDate, { seconds: 0, milliseconds: 0 }),
                            set(this.toDate, { seconds: 0, milliseconds: 0 })
                        );
                    }
                    return true;
                },
            },
            timeToFormatted: {
                incorrectTime: val => {
                    return this.incorrectTimeChecker(val);
                },
                timeDiffTo: () => {
                    if (this.value.from.date && this.value.to.date) {
                        return isBefore(
                            set(this.fromDate, { seconds: 0, milliseconds: 0 }),
                            set(this.toDate, { seconds: 0, milliseconds: 0 })
                        );
                    }
                    return true;
                },
            },
            validationGroup: ['dateFromFormatted', 'dateToFormatted', 'timeFromFormatted', 'timeToFormatted'],
        };
    },
};
</script>
